import orderingRoutes from '../../../routes/ordering';
import rewardsRoutes from '../../../routes/rewards';

export const navigationalPanelRoutes = [
  rewardsRoutes.containers.home,
  rewardsRoutes.containers.locations,
  rewardsRoutes.containers.account,
  rewardsRoutes.containers.ordering,
  rewardsRoutes.containers.wallet,
  `${rewardsRoutes.containers.wallet}/${rewardsRoutes.wallet.home}`,
  `${orderingRoutes.containers.menu}/*`,
];

export const datePickerSettings = {
  openTo: 'year',
  views: ['year', 'month', 'day'],
  toolbarFormat: 'DD MMM YYYY',
};

export const orderTypes = {
  dineIn: 'DI',
  selfPickup: 'SP',
  delivery: 'DL',
};

export const rewardSignUpStates = {
  getStarted: 'GET_STARTED',
  enterNumber: 'ENTER_NUMBER',
  verifyNumber: 'VERIFY_NUMBER',
  enterDetails: 'ENTER_DETAILS',
  selectOutlet: 'SELECT_OUTLET',
};

export const rewardSigninStates = {
  enterNumber: 'ENTER_NUMBER',
  verifyNumber: 'VERIFY_NUMBER',
};

export const pointUnits = {
  percent: 'PER',
  absolute: 'ABS',
  item: 'ITM',
};

export const announcementBannerCarouselSettings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  lazyload: 'progressive', // accepts 'onDemand | progressive'
  variableWidth: true,
};

/** Faster autoplay for website home marketing / loyalty-style banner carousel. */
export const siteAnnouncementBannerCarouselSettings = {
  ...announcementBannerCarouselSettings,
  speed: 500,
  autoplaySpeed: 1500,
  // Two fixed tiles on desktop — avoids variableWidth peeks of a 3rd slide.
  slidesToShow: 2,
  slidesToScroll: 1,
  variableWidth: false,
  infinite: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: false,
      },
    },
  ],
};

export const rewardCardsCarouselSettings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 3000,
  lazyload: 'progressive', // accepts 'onDemand | progressive'
};

export const couponCardsCarouselSettings = {
  dots: false,
  arrows: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 3000,
  lazyload: 'progressive', // accepts 'onDemand | progressive'
  variableWidth: true,
};

export const outletImagesCarouselSettings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  lazyload: 'progressive', // accepts 'onDemand | progressive'
};

export const rewardSettings = {
  home: 'HOME',
  profile: 'PROFILE',
  rewardHistory: 'REWARDS_HISTORY',
  rewardProgram: 'REWARDS_PROGRAM',
  settings: 'SETTINGS',
  favouriteLocation: 'FAVOURITE_LOCATION',
  helpSupport: 'HELP_SUPPORT',
  vipPass: 'VIP_PASS',
  myRewards: 'MY_REWARDS',
};

export const minAgeYearsForRewardOnboarding = 8;

export const rewardTransactionCategory = {
  credit: 'C',
  debit: 'D',
};

export const rewardSourceType = {
  order: 'ORDER',
  coupon: 'COUPON',
};

export const rewardTransactionType = {
  reward: 'REW',
  redeem: 'RED',
  payment: 'PYMT',
  default: 'DF',
  referral: 'REFERRAL',
  walletRechargeBonus: 'WALLET_RECHARGE_BONUS'
};

export const accountHistoryView = {
  point: 'point-history',
  reward: 'reward-history',
  order: 'order-history',
};

export const rewardType = {
  added: 'Added',
  deducted: 'Deducted',
  adjusted: 'Adjusted',
};
const { BIRTHDAY_REWARD_PRE_MONTHS, ANNIVERSARY_REWARD_PRE_MONTHS } =
  '_env' in window && window._env;

export const birthdayRewardPreMonths = BIRTHDAY_REWARD_PRE_MONTHS;

export const anniversaryrewardPreMonths = ANNIVERSARY_REWARD_PRE_MONTHS;

export const dateFilterConfig = {
  filters: {
    default: { code: 'DF', title: 'All time' },
    custom: { code: 'C', title: 'Custom' },
    thisWeek: { code: 'TW', title: 'This week' },
    thisMonth: { code: 'TM', title: 'This month' },
    lastWeek: { code: 'LW', title: 'Last week' },
    lastMonth: { code: 'LM', title: 'Last month' },
  },

  filterDateFormat: 'DD MMM YYYY',
};

export const rewardPointFilter = [
  { title: 'All', code: 'ALL' },
  { title: 'Earned', code: 'EARNED' },
  { title: 'Used', code: 'USED' },
];

export const walletTransactionCategory = {
  credit: 'C',
  debit: 'D',
};

export const walletTransactionCategoryFilter = [
  { title: 'All', code: 'ALL' },
  { title: 'Credit', code: walletTransactionCategory.credit },
  { title: 'Debit', code: walletTransactionCategory.debit },
];

export const walletTransactionType = {
  recharge: 'RECHARGE',
  benefit: 'BENEFIT',
  spendOrder: 'SPEND_ORDER',
  spendPass: 'SPEND_PASS',
  manualAdd: 'MANUAL_ADD',
  manualDeduct: 'MANUAL_DEDUCT',
  expired: 'EXPIRED',
  refund: 'REFUND',
  all: 'ALL',
};

export const walletBenefitType = {
  walletBonus: 'WALLET_BONUS',
  loyaltyBonus: 'LOYALTY_BONUS',
  coupon: 'COUPON',
};

export const walletTransactionTypeFilter = [
  { title: 'All', code: walletTransactionType.all },
  { title: 'Recharge', code: walletTransactionType.recharge },
  { title: 'Benefit', code: walletTransactionType.benefit },
  { title: 'Spend Order', code: walletTransactionType.spendOrder },
  { title: 'Spend Pass', code: walletTransactionType.spendPass },
  { title: 'Manual Add', code: walletTransactionType.manualAdd },
  { title: 'Manual Deduct', code: walletTransactionType.manualDeduct },
  { title: 'Expired', code: walletTransactionType.expired },
  { title: 'Refund', code: walletTransactionType.refund },
];

export const rewardFilter = [
  { title: 'All', code: 'ALL' },
  { title: 'Claimed', code: 'CLAIMED' },
  { title: 'Redeemed', code: 'REDEEMED' },
  { title: 'Expired', code: 'EXPIRED' },
];

export const rewardCategory = {
  bday: 'BDAY',
  rewardPoints: 'REWARD_COUPON',
  campaign: 'CM',
  reward: 'RW',
  welcome: 'WELCOME',
  pointOffer: 'REWARD_POINT',
  anniversary: 'ANNIVERSARY',
  tierUpgrade: 'TIER_UPGRADE',
  rewardCouponInstant: "REWARD_COUPON_INSTANT",
};

export const pointPriceExcludeRewardCategories = [
  rewardCategory.bday,
  rewardCategory.welcome,
  rewardCategory.anniversary,
  rewardCategory.tierUpgrade,
  'FB',
];

export const nativeEventType = {
  appVersion: 'app-version',
  location: 'location',
  routeName: 'routeName',
  hardwareBackPress: 'hardwareBackPress',
  verifyPayment: 'verify-payment',
  appStartupInfo: 'appStartupInfo',
  nativeAppUpdateAvailable: 'nativeAppUpdateAvailable',
  disableKBAvoidingScroll: 'disable-kb-avoiding-scroll',
  disableKBAvoidingView: 'disable-kb-avoiding-view',
  navigateToPage: 'navigateToPage',
  brandGuestData: 'brandGuestData',
  resetState: 'resetState',
  userLocation: 'user-location',
  goBack: 'go-back',
  canGoBack: 'can-go-back',
  isNearbyOutletPickerEnabled: 'is-nearby-outlet-picker-enabled',
  nativeBackPress: 'nativeBackPress',
  selectLocation: 'select-location',
  deliveryLocation: 'delivery-location',
  selectOrderOutlet: 'select-order-outlet',
  lastOrderData: 'last-order-data',
  exitPayEarn: 'exit-pay-earn',
  exitBookTable: 'exit-book-table',
  canExitModule: 'can-exit-module',
  currentLocation: 'current-location',
  viewCartData: 'view-cart-data',
  nativeRouteName: 'nativeRouteName',
  clearCartAction: 'clearCartAction',
  showOutletsPopup: 'show-outlets-popup',
  updateMenuCart: 'update-menu-cart',
  restaurantSelection: 'restaurant-selection',
  scrollToMenuItem: 'scroll-to-menu-item',
  sessionExpired: 'session-expired',
  sessionHandled: 'session-handled',
  accessDenied: 'access-denied',
  kBFocusScrollToTop: 'kb-focus-scroll-to-top',
  dispatchDealOfferData: 'dispatch-deal-offer-data',
  dispatchCartFromNative: 'cart-from-native',
  themeData: 'theme-data',
  guestMode: 'guest-mode',
  nativeTokenRefreshRequest: 'native-token-refresh-request',
  nativeTokenRefreshed: 'native-token-refreshed',
  nativeTokenRefreshFailed: 'native-token-refresh-failed',
  communityContext: 'community-context',
  communitySlot: 'community-slot',
  openLocationSelection: 'open-location-selection',
  appReady: 'appReady',
};

export const defaultFooterConfiguration = [
  {
    title: 'Rewards',
    route: 'home',
    icon: 'https://devassets.fudr.in/brand/freddiestg/Rewards.png',
  },
  {
    title: 'Order',
    route: 'ordering',
    icon: 'https://devassets.fudr.in/brand/freddiestg/Order.png',
  },
  {
    title: 'Locations',
    route: 'locations',
    icon: 'https://devassets.fudr.in/brand/freddiestg/location.png',
  },
  {
    title: 'More',
    route: 'account',
    icon: 'https://devassets.fudr.in/brand/freddiestg/More.png',
  },
];

export const rewardRules = {
  spend: 'SPEND',
  rewardCoupon: 'REWARD_COUPON',
  fixedPoints: 'FIXED_POINTS',
};

export const appOrderingStatusCodes = {
  comingSoon: 'DEMO',
  active: 'ACTIVE',
};

export const rewardTypes = {
  rewardPoint: 'RP',
};

export const referralRewardTypes = {
  rewardPoint: 'REWARD_POINT',
  deal: 'COUPON',
};

export const brandModuleCodes = {
  appOrder: 'appOrder',
  reward: 'reward',
  pass: 'pass',
  payAndEarn: 'payAndEarn',
  reservation: 'reservation',
  feedback: 'feedback',
  referral: 'referral',
  wallet: 'wallet',
  menuTagSuggestion: 'menutagsuggestion',
  appVisibility: 'appvisibility',
  website: 'website',
  loyaltyApp: 'loyaltyApp',
  externalLoyalty: 'externalLoyalty',
  // Not used for gating yet — dark store delivery is brandResource.resource.enableDarkStoreDelivery.
  darkStoreDelivery: 'darkStoreDelivery',
};

// Guest mode configuration - whitelist approach
// Only whitelisted components and APIs are allowed for guest users
export const guestModeConfig = {
  // Whitelisted component identifiers for guest users
  whitelistedComponents: [
    'GreeterSection',
    'BrandPromotion',
    'PromotionalBanner',
    'LoyaltyCard',
    'SpotlightCard',
    'FeaturedItemCard',
    'NewlyLaunchedOutlets',
    'LevelTab', // Level tab is visible in guest mode
    'FaqsTab', // FAQs tab is visible in guest mode
    'BenefitDetails', // Benefit details (welcome, birthday, anniversary info) are visible in guest mode
    // Note: MyBenefitsTab is NOT whitelisted, so it won't show in guest mode
  ],

  // Whitelisted API identifiers for guest users (no user-specific data)
  // Only these APIs are allowed to be called in guest mode
  whitelistedAPIs: [
    // Add any public/non-user-specific APIs here if needed in future
    // Example: 'fetchPublicDeals', 'fetchBrandInfo'
  ],

  // Component identifier mappings for the actual components in JSX
  componentIdentifiers: {
    // Visible components
    GREETER_SECTION: 'GreeterSection',
    BRAND_PROMOTION: 'BrandPromotion',
    PROMOTIONAL_BANNER: 'PromotionalBanner',
    LOYALTY_CARD: 'LoyaltyCard',
    SPOTLIGHT_CARD: 'SpotlightCard',
    FEATURED_ITEM_CARD: 'FeaturedItemCard',
    NEWLY_LAUNCHED_OUTLETS: 'NewlyLaunchedOutlets',

    // Hidden components (user-specific)
    UPDATE_REWARD_SECTION: 'UpdateRewardSection',
    VIP_PASS_CARD: 'VIPPassCard',
    VIP_PASS_BANNER_CARD: 'VIPPassBannerCard',
    SPECIAL_CARD: 'SpecialCard', // Welcome/Birthday/Anniversary rewards (interactive cards)
    BENEFIT_DETAILS: 'BenefitDetails', // Benefit details (welcome, birthday, anniversary info sections)
    MY_COUPONS_SECTION: 'MyCouponsSection',
    LIMITED_TIME_OFFERS: 'LimitedTimeOffers',
    REFERRAL_CARD: 'ReferralCard',
    FEEDBACK_BANNER: 'FeedbackBanner',
    WELCOME_POPUP: 'WelcomePopup',
    UPDATE_REWARD_POPUP: 'UpdateRewardPopup',
    MEMBERSHIP_EXPIRED_POPUP: 'MembershipExpiredPopup',
    FEEDBACK_POPUP: 'FeedbackPopup',

    // Tab identifiers
    MY_BENEFITS_TAB: 'MyBenefitsTab',
    LEVEL_TAB: 'LevelTab',
    FAQS_TAB: 'FaqsTab',
  },

  // API identifier mappings
  apiIdentifiers: {
    CHECK_GUEST_COUPONS: 'checkGuestCoupons',
    FETCH_GUEST_COUPONS: 'fetchGuestCoupons',
    FETCH_EXTERNAL_OFFERS: 'fetchExternalOffers',
    FETCH_REWARD_POINTS: 'fetchRewardPoints',
  },
};

// Legacy exports for backward compatibility
export const guestWhitelistedComponents = guestModeConfig.whitelistedComponents;
export const guestWhitelistedAPIs = guestModeConfig.whitelistedAPIs;

export const loyaltyCarouselSettings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  lazyload: 'progressive', // accepts 'onDemand | progressive'
  variableWidth: true,
};
